import { render, staticRenderFns } from "./MouseScroll.vue?vue&type=template&id=4b9d516c&scoped=true&"
var script = {}
import style0 from "./MouseScroll.vue?vue&type=style&index=0&id=4b9d516c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d516c",
  null
  
)

export default component.exports